import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function TiktokMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 28 32" fill={color} style={style}><path d="M23.818 6.414A7.668 7.668 0 0120.32 0H14.8l-.009 22.048a4.635 4.635 0 01-6.784 3.92 4.625 4.625 0 01-2.487-4.094c0-2.55 2.081-4.625 4.64-4.625.477 0 .935.079 1.369.214v-5.617c-.449-.06-.905-.098-1.37-.098C4.559 11.748 0 16.29 0 21.873c0 3.426 1.718 6.457 4.338 8.29A10.125 10.125 0 0010.16 32c5.602 0 10.16-4.543 10.16-10.126v-11.18A13.156 13.156 0 0028 13.155V7.654a7.65 7.65 0 01-4.182-1.24z"  /></Svg>;
}
export default TiktokMedium;